<template>
  <div class="layout-detail-three-columns content-wrapper dark:bg-darkblue-900 flex flex-col w-full relative">
    <slot name="header" />
    <article ref="main" class="content flex flex-col flex-auto overflow-y-auto lg:overflow-y-hidden w-full">
      <div
        :class="{ 'lg:max-w-twocol': !toEdge }"
        :style="{ '--left-height': mainHeight }"
        class="column-container w-full flex flex-col lg:flex-row lg:mr-auto flex-grow relative"
      >
        <!-- LEFT COL -->
        <div
          class="left-col w-full relative overflow-y-hidden lg:overflow-y-auto lg:h-[var(--left-height)]"
          :class="[customLeft, {'w-11/12' : isLower1024}]"
        >
          <slot name="LeftCol" />
        </div>

        <!-- MIDDLE COL -->
        <div
          class="middle-col w-full relative mr-12 overflow-y-hidden lg:overflow-y-auto lg:h-[var(--left-height)]"
          :class="[customMiddle, middleRightClass, {'w-11/12' : isLower1024}]"
        >
          <slot name="MiddleCol" />
        </div>

        <!-- RIGHT COL CON BOTÓN Y PANEL -->
        <div
          class="right-col-container w-full flex flex-row items-center lg:h-[var(--left-height)] absolute right-0 top-0 h-full z-10 transition-all duration-300 overflow-hidden"
          :class="[customRight, middleRightClass, { '!w-12': isCollapsed && !isHovered, '!items-baseline': isLower1024 }]"
          @mouseenter="isHovered = !isLower1024"
          @mouseleave="isHovered = false"
        >
          <!-- BOTÓN -->
          <div 
            class="toggle-button mx-1"
            :class="{'!h-screen' : isLower1024}">
            <base-button-icon 
              class="rotate-180"
              :name="isCollapsed ? 'expand' : 'collap'"
              @click="toggleRightCol"
            />
          </div>

          <!-- PANEL DERECHO -->
          <transition name="slide-right">
            <div
              v-show="!isCollapsed || isHovered"
              class="right-col w-full h-full overflow-y-hidden lg:overflow-y-auto transition-all duration-300"
              :class="{ 'no-slide': isCollapsed, '!self-center !pr-4' : isLower1024 }"
            >
              <slot name="RightCol" />
            </div>
          </transition>
        </div>
      </div>
    </article>
    <slot name="layout-extend" />
  </div>
</template>

<script>
export default {
  name: 'layout-detail-three-columns-no-fixed-collapsible',
  props: {
    toEdge: {
      type: Boolean,
      default: false
    },
    customLeft: {
      type: [Array, Object, String],
      default: ''
    },
    customMiddle: {
      type: [Array, Object, String],
      default: ''
    },
    customRight: {
      type: [Array, Object, String],
      default: ''
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mainHeight: 'auto',
      resizeObserver: null,
      isCollapsed: false,
      isHovered: false
    }
  },
  created () {
    this.isCollapsed = this.collapsed
  },
  watch: {
    collapsed: function (value, oldValue) {
      if (value !== oldValue) {
        this.isCollapsed = !!value
      }
    },
    isCollapsed: function (value, oldValue) {
      if (value !== oldValue) {
        this.$emit('update:collapsed', !!value)
      }
    }
  },
  mounted () {
    const mainElement = this.$refs.main
    if (mainElement) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateMainHeight()
      })
      this.resizeObserver.observe(mainElement)
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    middleRightClass: function () {
      return [
        'bg-primary-50',
        'dark:bg-darkblue-800',
        'dark:text-darkblue-200',
        'divide-y-2',
        'divide-blue-200',
        'dark:divide-gray-800',
      ]
    }
  },
  methods: {
    updateMainHeight () {
      const mainElement = this.$refs.main
      if (mainElement) {
        this.mainHeight = getComputedStyle(mainElement).height
      }
    },
    toggleRightCol () {
      this.isCollapsed = !this.isCollapsed
    }
  },
  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  }
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  width: 100%;
  @include breakpoint(lg) {
    width: calc(100% - 18.125rem);
  }
}

.aside-is-collapsed {
  .content-wrapper {
    @include breakpoint(lg) {
      width: calc(100% - 4.5rem);
    }
  }
}

.right-col-container {
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  .right-col {
    transition: all 0.3s ease;
  }

  .toggle-button {
    width: 2.5rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

<style>
@property --left-height {
  syntax: "<length-percentage>|auto";
  inherits: true;
  initial-value: auto;
}

@media (width < 1300px) {
  .column-container {
    flex-direction: column;
  }
}

/* Normal slide */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

/* Entrada (slide desde la derecha) */
.slide-right-enter {
  opacity: 0;
  transform: translateX(100%);
}

/* Salida (slide hacia la derecha) */
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
